import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
const factory = create({ theme }).properties();
export const HTMLObject = factory(({ properties, middleware: { theme } }) => {
    const { topicdata, additionalClasses = [] } = properties();
    const topicvalues = topicdata;
    const { attributes } = topicvalues;
    const file = attributes.data.split('/').pop() || '';
    const path = `${window.hcstatic.portal_cdn}/files/video/${file}`;
    return v('video', {
        autoplay: false,
        controls: true,
        controlsList: 'nodownload',
        language: window.hcstatic.portal_language || 'en',
        preload: 'auto',
        classes: [...additionalClasses],
        styles: {
            maxWidth: '80%'
        }
    }, [
        v('source', {
            src: path,
            type: 'video/mp4'
        })
    ]);
});
